"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.factory = factory;

var _core = require("./core");

var _security = require("./security");

var _reflection = require("./reflection");

var _annotations = require("./annotations");

var _imageAnalysis = require("./image-analysis");

var _user = require("./user");

function factory(http, tokenProvider) {
  // Create a client to access dataserver and inject the transport:
  var client = new _core.clients.ImageManagementClient(http);
  var securityClient = new _core.clients.SecurityClient(http); // Create and use an auth interceptor to include a token in each request:

  var authInterceptor = new _core.interceptors.AuthInterceptor(tokenProvider);
  authInterceptor.install(client, securityClient); // Instantiate all the providers

  return {
    client: client,
    securityClient: securityClient,
    security: walkAndCreate(_security.providers, securityClient),
    reflection: walkAndCreate(_reflection.providers, client),
    annotations: walkAndCreate(_annotations.providers, client),
    imageAnalysis: walkAndCreate(_imageAnalysis.providers, client),
    user: walkAndCreate(_user.providers, client)
  };
}

function walkAndCreate(providerList, client) {
  var module = {};
  Object.keys(providerList).forEach(function (p) {
    module[toCamelCase(p)] = new providerList[p](client);
  });
  return module;
}

var toCamelCase = function toCamelCase(text) {
  return text.replace(/^\w/, function (c) {
    return c.toLowerCase();
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/factory.js
// module id = 248
// module chunks = 0